import React, { Fragment } from 'react'

import { faCheck, faSync, faTimes } from '@fortawesome/pro-regular-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { Box, List, ListItem, Typography } from '@material-ui/core'
import { NonDismissibleDialog } from '@scoir/modals'
import { map, reject } from 'lodash'
import PropTypes from 'prop-types'

import { isCredibleDate } from 'common/date'

const { Body, Footer } = NonDismissibleDialog
const { PrimaryActionButton, CloseButton } = Footer

class InviteUsersModal extends React.Component {
  canUsersBeInvited() {
    const unregisteredStaff = reject(this.props.users, { Confirmed: true })
    return unregisteredStaff.length > 0
  }

  submitInvites() {
    const unregisteredStaff = reject(this.props.users, { Confirmed: true })
    const staff = map(unregisteredStaff, 'Id')
    this.props.onSubmit(staff)
    this.props.onClose()
  }

  renderRecord(user) {
    if (user.Confirmed) {
      return (
        <Fragment>
          <Box
            color="error.dark"
            mr={1}
          >
            <FontAwesomeIcon
              color="inherit"
              icon={faTimes}
            />
          </Box>
          <Typography>{`${user.LastName}, ${user.FirstName} - already registered`}</Typography>
        </Fragment>
      )
    } else if (isCredibleDate(user.ConfirmationRequestDate)) {
      return (
        <Fragment>
          <Box
            color="warning.main"
            mr={1}
          >
            <FontAwesomeIcon
              color="inherit"
              icon={faSync}
            />
          </Box>
          <Typography>{`${user.LastName}, ${user.FirstName} - resend invite`}</Typography>
        </Fragment>
      )
    }
    return (
      <Fragment>
        <Box
          color="success.main"
          mr={1}
        >
          <FontAwesomeIcon
            color="inherit"
            icon={faCheck}
          />
        </Box>
        <Typography>{`${user.LastName}, ${user.FirstName}`}</Typography>
      </Fragment>
    )
  }
  render() {
    return (
      <NonDismissibleDialog
        open={this.props.open}
        onClose={this.props.onClose}
        scroll="paper"
        headerText="Invite Staff"
      >
        <Body>
          <Typography variant="h6">Selected Staff</Typography>
          <List>
            {this.props.users.map((user, idx) => (
              <ListItem
                key={user.Id}
                divider={idx === this.props.users.length - 1 ? false : true}
              >
                <Box
                  display="flex"
                  alignItems="center"
                >
                  {this.renderRecord(user)}
                </Box>
              </ListItem>
            ))}
          </List>
        </Body>
        <Footer>
          <CloseButton>Close</CloseButton>
          <PrimaryActionButton
            disabled={this.canUsersBeInvited() ? false : true}
            onClick={() => this.submitInvites()}
          >
            Invite
          </PrimaryActionButton>
        </Footer>
      </NonDismissibleDialog>
    )
  }
}

InviteUsersModal.propTypes = {
  open: PropTypes.bool,
  onClose: PropTypes.func,
  users: PropTypes.array,
  onSubmit: PropTypes.func,
}

export default InviteUsersModal
